export const colors = {
    primaryColor: '#e9465e', //soft red cover
    secondaryColor: '#1f9098' //harsh blue from cover
}